module.exports = __webpack_public_path__ + "media/svg/bj-25b670b1.svg";